import { render, staticRenderFns } from "./visitApplyMedicine.vue?vue&type=template&id=9fa547b8&scoped=true"
import script from "./visitApplyMedicine.vue?vue&type=script&lang=js"
export * from "./visitApplyMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa547b8",
  null
  
)

export default component.exports